/**
 * Productos Virales - Custom Features
 * Contiene: WhatsApp button, countdown, announcement bar scroll, Buy Now button customization
 * Config editable via window.PV_CONFIG (definida en layout/theme.liquid)
 */
(function () {
  "use strict";

  var cfg = window.PV_CONFIG || {};

  // ==========================================
  // 1) WhatsApp button — link dinamico segun pagina
  // ==========================================
  function initWhatsAppButton() {
    var link = document.getElementById("whatsapp-link");
    if (!link) return;

    var baseUrl = "https://wa.me/" + (cfg.whatsappNumber || "51906597689") + "?text=";
    var isProductPage = window.location.pathname.indexOf("/products/") !== -1;

    var message;
    if (isProductPage) {
      var productEl = document.querySelector(".productView-title");
      var productTitle = productEl ? productEl.innerText : null;
      if (productTitle) {
        message = (cfg.whatsappProductPrefix || "Hola, quiero pedir el producto: ") + productTitle;
      } else {
        message = cfg.whatsappProductFallback || "Hola, estoy interesado en un producto";
      }
    } else {
      message = cfg.whatsappPageMessage || "Hola, vengo de la pagina web";
    }

    link.href = baseUrl + encodeURIComponent(message);
  }

  // ==========================================
  // 2) Countdown - free shipping deadline
  // ==========================================
  function initCountdown() {
    var el = document.getElementById("countdown");
    if (!el) return;

    var KEY = cfg.countdownStorageKey || "pv_free_shipping_deadline";
    var DURATION_MS = cfg.countdownDurationMs || (60 * 60 * 1000); // 1 hora default

    function getEndTime() {
      var stored = localStorage.getItem(KEY);
      var end = stored ? new Date(stored) : null;
      var now = new Date();
      if (!end || isNaN(end.getTime()) || end <= now) {
        end = new Date(now.getTime() + DURATION_MS);
        localStorage.setItem(KEY, end.toISOString());
      }
      return end;
    }

    function update() {
      if (document.hidden) return;
      var now = new Date();
      var end = getEndTime();
      var remaining = Math.max(0, Math.floor((end - now) / 1000));
      var hours = Math.floor(remaining / 3600);
      remaining %= 3600;
      var minutes = Math.floor(remaining / 60);
      var seconds = remaining % 60;

      el.innerHTML =
        '<div class="countdown-segment">' +
        '<div class="value">' + String(hours).padStart(2, "0") + '</div>' +
        '<div class="label">Horas</div>' +
        '</div>' +
        '<span class="countdown-separator">:</span>' +
        '<div class="countdown-segment">' +
        '<div class="value">' + String(minutes).padStart(2, "0") + '</div>' +
        '<div class="label">Minutos</div>' +
        '</div>' +
        '<span class="countdown-separator">:</span>' +
        '<div class="countdown-segment">' +
        '<div class="value">' + String(seconds).padStart(2, "0") + '</div>' +
        '<div class="label">Segundos</div>' +
        '</div>';
    }

    var interval = setInterval(update, 1000);
    update();

    // Pausar cuando la pestana no esta visible (ahorra CPU/bateria)
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) update();
    });
  }

  // ==========================================
  // 3) Announcement bar - hide on scroll down, show on scroll up
  // ==========================================
  function initAnnouncementBarScroll() {
    var bar = document.getElementById("announcementBar");
    if (!bar) return;

    var lastScroll = window.pageYOffset || document.documentElement.scrollTop;
    var threshold = 5;
    var ticking = false;

    function onScroll() {
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll === 0) {
        bar.classList.remove("hide");
      } else if (currentScroll - lastScroll > threshold) {
        bar.classList.remove("hide");
      } else if (lastScroll - currentScroll > threshold) {
        if (currentScroll > 0) bar.classList.add("hide");
      }
      lastScroll = currentScroll;
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // ==========================================
  // 4) Buy Now button - cambiar "Comprar ahora" por texto custom
  // ==========================================
  function initBuyNowCustomization() {
    var originalText = cfg.buyNowOriginalText || "Comprar ahora";
    var newText = cfg.buyNowNewText || "Programar Pedido Ahora";

    function customize(btn) {
      if (!btn || btn.dataset.pvCustomized) return;
      if (btn.textContent.trim() !== originalText) return;
      btn.dataset.pvCustomized = "1";
      btn.style.display = "flex";
      btn.style.flexDirection = "column";
      btn.style.justifyContent = "center";
      btn.style.alignItems = "center";
      btn.style.lineHeight = "1.2";
      btn.style.textAlign = "center";
      btn.innerHTML =
        '<span style="font-weight:bold;">' + newText + '</span>' +
        '<span style="font-size:12px;color:#fff;opacity:0.9;"></span>';
    }

    function customizeAll() {
      var btns = document.querySelectorAll("shopify-buy-it-now-button button");
      for (var i = 0; i < btns.length; i++) customize(btns[i]);
    }

    // Pasada 1: botones presentes al cargar (caso pagina de producto)
    customizeAll();

    // Pasada 2: re-chequear en interacciones (caso cart drawer / quick view)
    document.addEventListener("click", function () {
      requestAnimationFrame(customizeAll);
    }, { passive: true });

    // Pasada 3: observer corto (max 10s) por si el web component se monta tarde
    var obs = new MutationObserver(customizeAll);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  // ==========================================
  // Init - todo se dispara en DOMContentLoaded
  // ==========================================
  function init() {
    try { initWhatsAppButton(); } catch (e) { console.warn("PV WhatsApp init error:", e); }
    try { initCountdown(); } catch (e) { console.warn("PV Countdown init error:", e); }
    try { initAnnouncementBarScroll(); } catch (e) { console.warn("PV AnnouncementBar init error:", e); }
    try { initBuyNowCustomization(); } catch (e) { console.warn("PV BuyNow init error:", e); }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ===========================================================
   SELLO "Garantia de satisfaccion" sobre la imagen principal
   (PDP). Inyecta el markup .pv-garantia-sello dentro de
   .productView-image-wrapper. El estilo vive en rediseno-pdp.css.
   Anadido: 2026-06-14 (Claude)
   =========================================================== */
(function () {
  function addBadge() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var wrap = document.querySelector('.productView-image-wrapper');
    if (!wrap || wrap.querySelector('.pv-garantia-sello')) return;
    var el = document.createElement('div');
    el.className = 'pv-garantia-sello';
    el.innerHTML =
      '<span class="pv-garantia-titulo">Garantía de satisfacción</span>' +
      '<span class="pv-garantia-sub">*7 días para devolverlo<br>!Sin preguntas!*</span>';
    wrap.appendChild(el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBadge);
  } else {
    addBadge();
  }
})();
